module.exports = __webpack_public_path__ + "img/1267634.6f2b1134.png";